import { AuthService } from './auth.service';

// export function initializeAuthFactory(authService: AuthService): () => Promise<void> {
//   return () => new Promise((resolve) => {
//     authService.setupSessionRefresh();
//     resolve();
//   });
// }

export function initializeAuthFactory(authService: AuthService): void {
  return authService.setupSessionRefresh();
  // return () => authService.setupSessionRefresh();
}